import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';

export function FirstTimeDiscountBanner() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if user has seen the banner before
    const hasSeen = localStorage.getItem('discount_banner_seen');
    if (!hasSeen) {
      setIsVisible(true);
    }
  }, []);

  const handleClose = () => {
    setIsVisible(false);
    localStorage.setItem('discount_banner_seen', 'true');
  };

  if (!isVisible) return null;

  return (
    <div className="bg-gradient-to-r from-purple-600 to-pink-500 text-white py-2 px-4 relative">
      <div className="container mx-auto max-w-6xl flex items-center justify-center gap-2 text-sm md:text-base">
        <span className="animate-pulse">🎉</span>
        <span className="font-medium">
          First Order? Use code <span className="font-bold bg-white/20 px-2 py-0.5 rounded">WELCOME10</span> for 10% OFF!
        </span>
        <span className="animate-pulse">🎉</span>
        <button
          onClick={handleClose}
          className="absolute right-2 md:right-4 p-1 hover:bg-white/20 rounded-full transition-colors"
          aria-label="Dismiss"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}

export default FirstTimeDiscountBanner;
